export enum SurveyCreatorConstants {
  GET_SCHEMA_TYPES_REQUEST = 'GET_SCHEMA_TYPES_REQUEST',
  GET_SCHEMA_TYPES_SUCCESS = 'GET_SCHEMA_TYPES_SUCCESS',
  GET_SCHEMA_TYPES_FAILURE = 'GET_SCHEMA_TYPES_FAILURE',

  GET_SCHEMA_REQUEST = 'GET_SCHEMA_REQUEST',
  GET_SCHEMA_SUCCESS = 'GET_SCHEMA_SUCCESS',
  GET_SCHEMA_FAILURE = 'GET_SCHEMA_FAILURE',

  SAVE_SURVEY_REQUEST = 'SAVE_SURVEY_REQUEST',
  SAVE_SURVEY_SUCCESS = 'SAVE_SURVEY_SUCCESS',
  SAVE_SURVEY_FAILURE = 'SAVE_SURVEY_FAILURE',

  SET_SELECTED_TYPE = 'SET_SELECTED_TYPE',
}
